export type Client = ClientIntakeData & {
  IS_PRIMARY_CLIENT: boolean;
  CLIENT_ID: string;
  HOUSEHOLD_ID: string;
  DOCUSIGN_WMA_ENVELOPE_ID?: string;
  DOCUSIGN_WDA_ENVELOPE_ID?: string;
};

export interface Clients {
  client: ClientIntakeData;
  coClient: ClientIntakeData;
}

export interface ClientWithoutCoClient {
  client: ClientIntakeData;
}

export interface ClientIntakeFormInputs {
  client: ClientIntakeData;
  coClient?: ClientIntakeData;
}

export interface ClientIntakeData {
  FIRST_NAME: string;
  LAST_NAME: string;
  EMAIL: string;
  PHONE_NUMBER: string;
  SSN: string;
  DOB: string;
  DRIVER_LICENSE_NUMBER: string;
  DRIVER_LICENSE_STATE: string;
  DRIVER_LICENSE_EXP: string;
  OCCUPATION?: string;
  EMPLOYMENT_STATUS?: string;
  EMPLOYER_NAME?: string;
  ADDRESS_STREET: string;
  ADDRESS_STREET_2?: string;
  ADDRESS_CITY: string;
  ADDRESS_STATE: string;
  ADDRESS_ZIP: string;
  MAILING_ADDRESS_STREET?: string | null;
  MAILING_ADDRESS_STREET_2?: string | null;
  MAILING_ADDRESS_CITY?: string | null;
  MAILING_ADDRESS_STATE?: string | null;
  MAILING_ADDRESS_ZIP?: string | null;
  HAS_FINRA_ASSOCIATION?: boolean;
}

export enum EmploymentStatus {
  EMPLOYED = "EMPLOYED",
  NOT_EMPLOYED = "NOT_EMPLOYED",
  RETIRED = "RETIRED",
}
